import RootStore from '.';
import BaseStore from './BaseStore';
import { flow, makeObservable, observable } from 'mobx';
import { ResponseData } from '@/types/http';
import { LocationSelect, Province, Region } from '@/types/location';
import RegionProvinceApi from '@/apis/RegionProvinceApi';

export default class RegionProvinceStore extends BaseStore {
    regions: Region[] = [];
    allRegion: any[] = [];
    provinces: Province[] = [];
    locationSelects: LocationSelect[] = [];
    api: RegionProvinceApi;

    constructor(rootStore: RootStore) {
        super(rootStore);
        makeObservable(this, {
            regions: observable,
            allRegion: observable,
            provinces: observable,
            locationSelects: observable,
            getRegions: flow.bound,
            getProvinces: flow.bound,
            getProvincesByRegion: flow.bound,
            getAllRegion: flow.bound,
            getLocationsByRegionProvince: flow.bound
        });
        this.api = new RegionProvinceApi();
    }

    *getRegions(size = 20, page = -1) {
        const payload = { size, page };
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.getRegions, payload);
            if (res.ok) {
                this.regions = res.data.elements;
                return res;
            }
            return false;
        } catch (error) {
        }
    }

    *getAllRegion(size = 20, page = -1) {
        const payload = { size, page };
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.getAllRegion, payload);
            if (res.ok) {
                this.allRegion = res.data;
            }
        } catch (error) {
        }
    }

    *getProvinces(size = 20, page = -1) {
        const payload = { size, page };
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.getProvinces, payload);
            if (res.ok) {
                this.provinces = res.data.elements;
                return res;
            }
            return false;
        } catch (error) {
        }
    }

    *getProvincesByRegion(regionId?: number, size = 20, page = -1) {
        const payload = { regionId, size, page };
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.getProvincesByRegion, payload);
            if (res.ok) {
                this.provinces = res?.data[0]?.provinces || [];
                return res;
            }
            return false;
        } catch (error) {
        }
    }

    *getLocationsByRegionProvince(payload) {
        try {
            const res: ResponseData = yield this.rootStore.apiStore.call(this.api, this.api.getLocationsByRegionProvince, payload);
            if (res.ok) {
                this.locationSelects = res?.data?.length > 0 ? res?.data : [];
                return res;
            }
            return false;
        } catch (error) {
        }
    }

    clean(): void {
        super.clean();
        this.regions = [];
        this.provinces = [];
        this.allRegion = [];
    }
}
